import { format, parseISO } from 'date-fns';

export const formatScreeningDate = (dateString: string) => {
    const date = parseISO(dateString);

    return `${format(date, 'dd MMM / HH:mm').toUpperCase()}`;
};
